import { render, staticRenderFns } from "./ComponentSidebar.vue?vue&type=template&id=25f30404&scoped=true&"
import script from "./ComponentSidebar.vue?vue&type=script&lang=js&"
export * from "./ComponentSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ComponentSidebar.vue?vue&type=style&index=0&id=25f30404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f30404",
  null
  
)

export default component.exports